import renderYandexCaptchaWidgetOnVisible from '@/yandex-captcha/renderCaptchaWidgetOnVisible';
import isSafari from '@/helpers/isSafari';

/**
 * Destroy и повторная инициализация виджета Yandex Captcha для Safari
 * @module reinitCaptchaIfSafari
 *
 * @description
 * В Safari на macOS при ошибке валидации с Yandex SmartCaptcha может происходить
 * нежелательный скролл вверх. Из всех возможных решений помогает только полная
 * реинициализация виджета.
 *
 * @param {Object} options - параметры для реинициализации
 * @param {Object} options.context - контекст компонента
 * @param {HTMLElement} options.captchaBlock - DOM-элемент блока капчи
 * @param {string} options.formType - тип формы ('comment', 'feedback', 'review')
 *
 * @returns {void}
 */
export default function({
  context,
  captchaBlock,
  formType
}) {
  if (!isSafari()) {
    return;
  }

  // Этот сброс нам нужно делать только тогда, когда пользователь выполнил задание капчи, потому что проблема кроется в том, как Safari обрабатывает фокус на элементах страницы после закрытия Iframe.
  const { activeElement } = document;
  if (activeElement && activeElement.tagName !== 'IFRAME') {
    return;
  }

  const tokenSelectors = [ '[name="yandex-smart-token"]', `[name="${formType}[yandex-smart-token]"]` ];

  try {
    // яндекс капча настолько кривая что после её ввода и отправки не закрывается клавиатура на мобильных устройствах
    activeElement.blur();

    // Дестроим виджет капчи
    const id = captchaBlock.dataset.yandexCaptchaWidgetId;
    if (id) {
      window.smartCaptcha.destroy(id);
    }

    // Сбрасываем токены
    const inputs = captchaBlock.querySelectorAll(tokenSelectors.join(', '));

    inputs.forEach((input) => {
      input.value = '';
    });

    // Рендерим виджет заново
    renderYandexCaptchaWidgetOnVisible({
      context,
      captchaBlock,
      formType
    });
  } catch (errorMessage) {
    console.error(
      `[reinitCaptchaIfSafari]. Произошла ошибка при попытке реинициализации виджета Yandex Captcha в браузере Safari ${formType}: `,
      errorMessage
    );
  }
}
